import React from "react";
import PropTypes from "prop-types";

export default function BuildInfo({ environment, versionHash }) {
  if (!versionHash || !["dev", "pre"].includes(environment)) {
    return null;
  }

  const shortHash = versionHash.substring(0, 7);

  return (
    <div className="fixed bottom-2 right-2 z-50 text-xs text-gray-500 opacity-70">
      Build {shortHash}
    </div>
  );
}

BuildInfo.propTypes = {
  environment: PropTypes.string,
  versionHash: PropTypes.string,
};
